import React from "react";
import DemoNavbar from "components/Navbars/DemoNavbar.jsx";
import CardsFooter from "components/Footers/CardsFooter";
import ChildPageBanner from "./layout/ChildPageBanner";
import BusinessImpactSection from "./layout/BusinessImpactSection";
import CapabilityCardsSection from "./layout/CapabilityCardsSection";

const banner = {
  background: "banner/ai-telecom.png",
  Title: "OUR BUSINESS",
  childTitle: "AI, CABLE NETWORKS &<br/>CONNECTIVITY",
  desktopCol: "8"
}

const impactSection = {
  titleLines: ["AI, CABLE NETWORKS &", "CONNECTIVITY"],
  paragraphs: [
    "HMG integrates strategic material sourcing, cable manufacturing partnerships, network engineering, and downstream project access to deliver high-performance connectivity solutions for AI data centers, telecom networks, energy projects, and large-scale infrastructure.",
    "As demand for bandwidth, power reliability, and low-latency connectivity accelerates, we support the critical cable and network infrastructure behind AI, cloud computing, and industrial digitalization—combining global supply access, EPC capabilities, and regional market expertise to enable next-generation growth."
  ],
  image: "content/ai-telecom1.png",
  imageAlt: "AI data center connectivity infrastructure"
};

const coreCapabilities = [
  {
    number: "01",
    title: "BACKBONE NETWORK DESIGN AND TELECOM INFRASTRUCTURE DEVELOPMENT",
    image: "content/ai-telecom2.png"
  },
  {
    number: "02",
    title: "FIBER OPTIC CABLE AND EQUIPMENT INSTALLATION",
    image: "content/ai-telecom3.png"
  },
  {
    number: "03",
    title: "AI DATA CENTER CONNECTIVITY AND NETWORK INTEGRATION",
    image: "content/ai-telecom1.png"
  },
  {
    number: "04",
    title: "POWER CABLE AND TELECOM CABLE SUPPLY-CHAIN COORDINATION",
    image: "content/ai-telecom4.png"
  },
  {
    number: "05",
    title: "SMART GRID AND RENEWABLE ENERGY NETWORK SUPPORT",
    image: "content/ai-telecom5.png"
  },
  {
    number: "06",
    title: "TECHNICAL CONSULTING, MAINTENANCE, TRAINING, AND TECHNOLOGY TRANSFER",
    image: "content/ai-telecom6.png"
  }
];

class AiTelecomNetworks extends React.Component {
  render() {
    return (
      <>
        <DemoNavbar />
        <main className="food commodity-supply-chain-page ai-telecom-networks-page" ref="main">
          <ChildPageBanner banner={banner} />
          <BusinessImpactSection {...impactSection} />
          <CapabilityCardsSection
            heading="CORE CAPABILITIES"
            capabilities={coreCapabilities}
            gridClassName="supply-chain-capabilities-grid--six"
          />
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default AiTelecomNetworks;
